import { create } from "zustand";

import { TutorProfileData } from "@/features/profile/tutor/types/profileData.ts";
import { SettingsData } from "@/features/profile/tutor/types/settingsData.ts";

type ProfileDataStore = {
  hasProfile: boolean | undefined;
  setHasProfile: (hasProfile: boolean | undefined) => void;
  profileData: TutorProfileData | undefined;
  setProfileData: (profileData: TutorProfileData | undefined) => void;
  toReload: boolean;
  setToReload: (toReload: boolean) => void;
  settingsData: SettingsData | undefined;
  setSettingsData: (settingsData: SettingsData | undefined) => void;
};

export const useProfileDataStore = create<ProfileDataStore>((set) => ({
  hasProfile: undefined,
  setHasProfile: (hasProfile: boolean | undefined) => {
    set({ hasProfile: hasProfile });
  },
  setProfileData: (profileData: TutorProfileData | undefined) => {
    set({ profileData });
  },
  profileData: undefined,
  toReload: false,
  setToReload: (toReload: boolean) => {
    set({ toReload: toReload });
  },
  settingsData: undefined,
  setSettingsData: (settingsData: SettingsData | undefined) => {
    set({ settingsData });
  },
}));
